import React from 'react';
import { notify, Thumbnail } from '@bynder/design-system';
import { IconCancel, IconCheck } from '@bynder/icons';
import { Translate } from '@bynder/localization';
import { BlankItem, MediaTypeSelection } from 'packages/pages/designCreateModal/components/Blank/types';
import { DesignSubPages } from 'packages/pages/designCreateModal/components/Sidebar/types';
import designsService from 'packages/services/designsService';
import { catchResponseError } from 'packages/helpers/helpers';
import { sendAppcuesEvent } from 'packages/helpers/RouteWithAppcues';
import { actionTypes } from './types';

export function setPage(page: DesignSubPages) {
    return {
        type: actionTypes.NEW_DESIGN_SET_PAGE,
        page,
    };
}

export function selectBlankType(selectedType: MediaTypeSelection) {
    return {
        type: actionTypes.NEW_DESIGN_BLANK_SELECT,
        selectedType,
    };
}

export function deselectBlankType(softMode?: boolean) {
    return {
        type: actionTypes.NEW_DESIGN_BLANK_DESELECT,
        softMode,
    };
}

export function setBlankType(selectedType: MediaTypeSelection, item: BlankItem) {
    return {
        type: actionTypes.NEW_DESIGN_BLANK_SET_VALUE,
        selectedType,
        item: { ...item, icon: undefined },
    };
}

export function createBlankDesign(collectionId?: string) {
    return async (dispatch, getState) => {
        dispatch({ type: actionTypes.NEW_DESIGN_BLANK_CREATE_REQUEST });

        const state = getState();
        const item: BlankItem = state.newDesign.blank[state.newDesign.blank.selectedType];

        const res = await designsService
            .createBlankDesign(
                {
                    type: state.newDesign.blank.selectedType,
                    pageName: item.label,
                    ...item.size,
                },
                collectionId,
            )
            .catch(catchResponseError);

        if (!res || res.status >= 400) {
            dispatch({ type: actionTypes.NEW_DESIGN_BLANK_CREATE_FAILURE });
            notify({
                thumbnail: (
                    <Thumbnail
                        variant="clean"
                        shape="circle"
                        backgroundColor="red500"
                        icon={<IconCancel />}
                        iconColor="white"
                    />
                ),
                title: <Translate id="modal.design.create.blank.message.failure" />,
            });

            return;
        }

        const pagePreset = item.label;
        const origin = 'Blank';
        const newDesign = res.json;

        dispatch({
            type: actionTypes.NEW_DESIGN_BLANK_CREATE_SUCCESS,
            newDesign,
            origin,
            sizePreset: pagePreset,
        });

        notify({
            thumbnail: (
                <Thumbnail
                    variant="clean"
                    shape="circle"
                    backgroundColor="green500"
                    icon={<IconCheck />}
                    iconColor="white"
                />
            ),
            title: <Translate id="modal.design.create.blank.message.success" />,
        });

        sendAppcuesEvent('Blank design created', { id: res.json.id, name: res.json.name, collectionId });

        dispatch(setPage(DesignSubPages.ALL));

        return `/designs/${res.json.id}/`;
    };
}

export function blankDesignQueried(creativeType: string, size: string, collectionId?: string) {
    return async (dispatch) => {
        dispatch({ type: actionTypes.NEW_DESIGN_BLANK_CREATE_REQUEST });
        const width = size.split('x')[0];
        const height = size.split('x')[1];

        const res = await designsService
            .createBlankDesign(
                {
                    type: creativeType,
                    width,
                    height,
                },
                collectionId,
            )
            .catch(catchResponseError);

        if (!res || res.status >= 400) {
            dispatch({ type: actionTypes.NEW_DESIGN_BLANK_CREATE_FAILURE });

            notify({
                thumbnail: (
                    <Thumbnail
                        variant="clean"
                        shape="circle"
                        backgroundColor="red500"
                        icon={<IconCancel />}
                        iconColor="white"
                    />
                ),
                title: <Translate id="modal.design.create.blank.message.failure" />,
            });
        } else {
            dispatch({ type: actionTypes.NEW_DESIGN_BLANK_CREATE_SUCCESS });

            notify({
                thumbnail: (
                    <Thumbnail
                        variant="clean"
                        shape="circle"
                        backgroundColor="green500"
                        icon={<IconCheck />}
                        iconColor="white"
                    />
                ),
                title: <Translate id="modal.design.create.blank.message.success" />,
            });

            dispatch(setPage(DesignSubPages.ALL));

            return `/designs/${res.json.id}/`;
        }
    };
}
